import { render, staticRenderFns } from "./Services.vue?vue&type=template&id=67d412cd&scoped=true&"
import script from "./Services.vue?vue&type=script&lang=jsx&"
export * from "./Services.vue?vue&type=script&lang=jsx&"
import style0 from "./Services.vue?vue&type=style&index=0&id=67d412cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d412cd",
  null
  
)

export default component.exports